
// GET /api/me (the backend session's user, e.g. after a Google sign-in), with
// concurrent callers sharing one request. NavbarTop and useAuthStatus both
// bootstrap from it on mount, so every page load used to send it twice.
// Only the in-flight request is shared - nothing is cached once it settles,
// so a later call (e.g. after logout) always asks the backend again.
// Resolves to the user object, or null when there is no session.
//
// Only asked when a backend session can exist: a Google sign-in was started
// in this browser (localStorage.pendingOAuth, set by Login.jsx before the
// redirect) or the backend's "avatar" cookie from a Google sign-in is
// present. Every anonymous visit used to send it and get a 401, which the
// browser logs as a console error on every page (Lighthouse Best Practices)
// and costs a request on the critical path. Password logins never needed it
// (they write localStorage.loginuserData directly).
let inFlight = null;

function mayHaveBackendSession() {
  try {
    if (localStorage.getItem("pendingOAuth")) return true;
  } catch {
    // storage blocked: fall through to the cookie check
  }
  return typeof document !== "undefined" && /(?:^|;\s*)avatar=/.test(document.cookie);
}

export function fetchMe({ timeoutMs, force = false } = {}) {
  if (!force && !mayHaveBackendSession()) return Promise.resolve(null);
  if (!inFlight) {
    inFlight = fetch(`https://api.hachion.co/api/me`, {
      credentials: "include",
      ...(timeoutMs ? { signal: AbortSignal.timeout(timeoutMs) } : {}),
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((u) => (u?.email ? u : null))
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}
